import type { TranslationDict } from '../types';

export const activities: TranslationDict = {
  detail: {
    backToCircle: {
      en: 'Back to {{name}}',
      'zh-CN': '返回 {{name}}',
      ja: '{{name}} に戻る',
    },
    back: {
      en: 'Back',
      'zh-CN': '返回',
      ja: '戻る',
    },
    loadFailed: {
      en: 'Failed to load activity',
      'zh-CN': '活动加载失败',
      ja: 'アクティビティの読み込みに失敗しました',
    },
    tryAgain: {
      en: 'Try again',
      'zh-CN': '重试',
      ja: '再試行',
    },
    notFoundTitle: {
      en: 'Activity not found',
      'zh-CN': '活动不存在',
      ja: 'アクティビティが見つかりません',
    },
    notFoundDesc: {
      en: "The activity you're looking for does not exist or has been removed.",
      'zh-CN': '你访问的活动不存在，或已被移除。',
      ja: 'お探しのアクティビティは存在しないか、削除されています。',
    },
    goBack: {
      en: 'Go back',
      'zh-CN': '返回上一页',
      ja: '戻る',
    },
  },
  strip: {
    title: {
      en: 'Activity Strip',
      'zh-CN': '活动速览',
      ja: 'アクティビティ一覧',
    },
    subtitle: {
      en: 'Live events & prompts',
      'zh-CN': '直播活动与话题',
      ja: 'ライブイベントとトピック',
    },
  },
  sidebar: {
    title: {
      en: 'Activities',
      'zh-CN': '活动',
      ja: 'アクティビティ',
    },
    empty: {
      en: 'No activities yet',
      'zh-CN': '暂时还没有活动',
      ja: 'まだアクティビティがありません',
    },
  },
  sections: {
    about: {
      en: 'About this opportunity',
      'zh-CN': '活动介绍',
      ja: 'この機会について',
    },
  },
  labels: {
    hostedBy: {
      en: 'Hosted by',
      'zh-CN': '主办方',
      ja: '主催者',
    },
    participants: {
      en: 'Participants',
      'zh-CN': '参与人数',
      ja: '参加者',
    },
    spotsLeft: {
      en: 'Spots left',
      'zh-CN': '剩余名额',
      ja: '残り枠',
    },
    type: {
      en: 'Type',
      'zh-CN': '类型',
      ja: 'タイプ',
    },
    prizePool: {
      en: 'Prize pool',
      'zh-CN': '奖池',
      ja: '賞金総額',
    },
    agenda: {
      en: 'Agenda',
      'zh-CN': '议程',
      ja: 'アジェンダ',
    },
    parking: {
      en: 'Parking',
      'zh-CN': '停车信息',
      ja: '駐車場',
    },
    dressCode: {
      en: 'Dress Code',
      'zh-CN': '着装要求',
      ja: 'ドレスコード',
    },
    speakers: {
      en: 'Speakers',
      'zh-CN': '演讲者',
      ja: '登壇者',
    },
    schedule: {
      en: 'Schedule',
      'zh-CN': '日程',
      ja: 'スケジュール',
    },
    status: {
      en: 'Status',
      'zh-CN': '状态',
      ja: 'ステータス',
    },
    rsvps: {
      en: 'RSVPs',
      'zh-CN': '报名数',
      ja: '参加登録',
    },
    online: {
      en: 'Online',
      'zh-CN': '线上',
      ja: 'オンライン',
    },
    inPerson: {
      en: 'In Person',
      'zh-CN': '线下',
      ja: '対面',
    },
    virtualEvent: {
      en: 'Virtual Event',
      'zh-CN': '线上活动',
      ja: 'オンラインイベント',
    },
    locationTBA: {
      en: 'Location details TBA',
      'zh-CN': '地点待公布',
      ja: '会場情報は後日公開',
    },
    viewOnMap: {
      en: 'View on map',
      'zh-CN': '在地图查看',
      ja: '地図で見る',
    },
    joinOnline: {
      en: 'Join online',
      'zh-CN': '在线加入',
      ja: 'オンラインで参加',
    },
    moreParticipants: {
      en: '+ {{count}} more participants',
      'zh-CN': '+ 另外 {{count}} 人参与',
      ja: '他 {{count}} 人が参加',
    },
    noParticipantsYet: {
      en: 'No participants yet',
      'zh-CN': '暂时还没有参与者',
      ja: 'まだ参加者はいません',
    },
  },
  actions: {
    downloadMaterials: {
      en: 'Download Materials',
      'zh-CN': '下载资料',
      ja: '資料をダウンロード',
    },
    watchLiveStream: {
      en: 'Watch Live Stream',
      'zh-CN': '观看直播',
      ja: 'ライブ配信を見る',
    },
  },
  counters: {
    joined: {
      en: '{{count}} joined',
      'zh-CN': '{{count}} 人已加入',
      ja: '{{count}}人が参加',
    },
    votes: {
      en: '{{count}} votes',
      'zh-CN': '{{count}} 票',
      ja: '{{count}}票',
    },
  },
  registration: {
    registered: {
      en: "You're registered!",
      'zh-CN': '你已报名！',
      ja: '登録済みです！',
    },
    cancelRegistration: {
      en: 'Cancel Registration',
      'zh-CN': '取消报名',
      ja: '登録をキャンセル',
    },
    applicationRequired: {
      en: 'Application required to join',
      'zh-CN': '需要申请后加入',
      ja: '参加には申請が必要です',
    },
    inviteOnly: {
      en: 'Invite only',
      'zh-CN': '仅限邀请',
      ja: '招待制',
    },
    freeToJoin: {
      en: 'Free to join',
      'zh-CN': '可直接加入',
      ja: '自由に参加可能',
    },
    joining: {
      en: 'Joining...',
      'zh-CN': '加入中...',
      ja: '参加中...',
    },
    eventEnded: {
      en: 'Event Ended',
      'zh-CN': '活动已结束',
      ja: 'イベント終了',
    },
    cancelled: {
      en: 'Cancelled',
      'zh-CN': '已取消',
      ja: '中止',
    },
    applyToJoin: {
      en: 'Apply to Join',
      'zh-CN': '申请加入',
      ja: '参加申請',
    },
    joinActivity: {
      en: 'Join Activity',
      'zh-CN': '加入活动',
      ja: '参加する',
    },
    joined: {
      en: 'Joined',
      'zh-CN': '已加入',
      ja: '参加済み',
    },
    joinThisActivity: {
      en: 'Join this Activity',
      'zh-CN': '加入这个活动',
      ja: 'このアクティビティに参加',
    },
    spotsRemaining: {
      en: '{{count}} spots remaining. RSVP to secure your place.',
      'zh-CN': '剩余 {{count}} 个名额，尽快报名锁定席位。',
      ja: '残り{{count}}枠です。参加登録して席を確保しましょう。',
    },
  },
  stats: {
    title: {
      en: 'Activity Stats',
      'zh-CN': '活动数据',
      ja: 'アクティビティ統計',
    },
  },
  types: {
    competition: { en: 'Competition', 'zh-CN': '竞赛', ja: 'コンペ' },
    prediction: { en: 'Prediction', 'zh-CN': '预测', ja: '予測' },
    ama: { en: 'AMA', 'zh-CN': 'AMA', ja: 'AMA' },
    workshop: { en: 'Workshop', 'zh-CN': '工作坊', ja: 'ワークショップ' },
    meetup: { en: 'Meetup', 'zh-CN': '线下聚会', ja: 'ミートアップ' },
    conference: { en: 'Conference', 'zh-CN': '大会', ja: 'カンファレンス' },
  },
  typeSections: {
    competition: { en: 'Competition', 'zh-CN': '竞赛', ja: 'コンペ' },
    predictionMarket: { en: 'Prediction Market', 'zh-CN': '预测市场', ja: '予測マーケット' },
    meetupDetails: { en: 'Meetup Details', 'zh-CN': '活动详情', ja: 'ミートアップ詳細' },
    workshopInfo: { en: 'Workshop Info', 'zh-CN': '工作坊信息', ja: 'ワークショップ情報' },
    amaSession: { en: 'AMA Session', 'zh-CN': 'AMA 访谈', ja: 'AMAセッション' },
    conference: { en: 'Conference', 'zh-CN': '大会', ja: 'カンファレンス' },
  },
  status: {
    upcoming: { en: 'Upcoming', 'zh-CN': '即将开始', ja: '開催予定' },
    ongoing: { en: 'Ongoing', 'zh-CN': '进行中', ja: '進行中' },
    ended: { en: 'Ended', 'zh-CN': '已结束', ja: '終了' },
    cancelled: { en: 'Cancelled', 'zh-CN': '已取消', ja: '中止' },
    live: { en: 'LIVE', 'zh-CN': '直播中', ja: 'LIVE' },
  },
  image: {
    coverAlt: {
      en: 'Activity cover',
      'zh-CN': '活动封面',
      ja: 'アクティビティカバー',
    },
  },
};
